import styled from 'styled-components'
import { colors } from '../../../../constants'

export const Header = styled.div`
    font-size: 15px;
    height: 50px;
`

export const SubHeader = styled.span`
    color: ${colors.grey};
    margin-left: 10px;
`

export const Body = styled.ul`
  align-items: flex-end;
  height: calc( 100% - 60px );
  margin: 0;
  padding: 0;
  width 100%;
`

export const ChartWrapper = styled.div`
    position: relative;
    height: 100%;
    overflow: hidden;
    width: 100%;
`
